module.exports = __webpack_public_path__ + "img/medication-btn.3a40039c.svg";